import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean> = (compact) => ({});

export const infoIcon: SxStyle = {
  color: (p) => p.palette.primary[100],
};

export const count: SxStyle = {
  fontWeight: 700,
};

export const creditInfo: SxStyleFunc<boolean> = (compact) => ({
  padding: (p) => p.spacing(0.5),
  fontSize: (p) => p.typography['body5' as 'caption'],
  borderRadius: (p) => p.spacing(0.5),
  borderWidth: '1px',
  borderColor: (p) => p.palette.primary[100],
  borderStyle: 'solid',
  color: (p) => p.palette.primary[500],
  background: (p) => p.palette.common.white,
  height: (p) => p.spacing(compact ? 2.75 : 2.25),
});

export const creditTag: SxStyle = {
  display: 'flex',
  alignItems: 'center',
};
